import { ApiResponse } from "../../../types/ApiResponse";
import api from "../../../utils/API";
import { UserDTO, UserUpdateDTO, UserUpdateSelfDTO } from "../dto";
import { User, UserMe } from "../entity";

export const getUserMe = (): ApiResponse<UserMe> => api.get("/v1/users/me");
export const getUser = (): ApiResponse<User[]> => api.get("/v1/users");
export const postUser = (params: UserDTO) => api.post("/v1/users", params);
export const updateUserSelf = (params: UserUpdateSelfDTO) =>
  api.put("/v1/users/self", params);
export const deleteUser = (id: string): ApiResponse<{ message: boolean }> =>
  api.delete(`/v1/users/${id}`);
export const getUserById = (id: string): ApiResponse<User> =>
  api.get(`/v1/users/${id}`);
export const updateUser = (params: UserUpdateDTO) =>
  api.put(`/v1/users/${params.id}`, params);
